import { makeStyles } from '@material-ui/core/styles';

type Props = {
    required?: boolean;
};

export const makeFormLabelStyles = makeStyles({
    root: ({ required }: Props) => {
        return {
            fontSize: '0.75rem',
            paddingTop: '0.125rem',
            paddingLeft: required ? '0.625rem' : '',
            position: 'relative',

            '&::before': required
                ? {
                      content: "'*'",
                      left: 0,
                      position: 'absolute',
                  }
                : {},

            '&:hover': {
                cursor: 'pointer',
            },
        };
    },
});
